import { OrderStatus } from "../ducks/order";

const getOrderHistoryStatus = (status: number): OrderStatus => {
  switch (status) {
    case 0:
      return OrderStatus.New;
    case 1:
      return OrderStatus.Registered;
    case 2:
      return OrderStatus.Cooking;
    case 3:
      return OrderStatus.Completed;
    case 9:
      return OrderStatus.Canceled;
    default:
      return OrderStatus.New;
  }
};

export { getOrderHistoryStatus };
